import { Common, ApiBind } from './common.model';

export class AllowedUserEmailDomain extends Common {
  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'domain' })
  domain: string;
}
